<template>
    <div class="float-left col text-muted p-item mb-2">
        <small>{{ control.name }}</small><br>
        <ul>
            <li v-for="(value, index) in splitValue()" :key="`DETAIL-${index}`" :class="value.class">
                <span >
                    <i :class="value.icon" :style="'font-size: 1.2rem;'"></i>
                </span>
                {{ value.name }}
            </li>
        </ul>
        
    </div>
</template>

<script>
//import AuditUtils from '@/components/pages/audit/AuditUtils.js'

export default {
    name: 'AuditNoteRadioGroup',

    props: {
        control: Object
    },

    methods: {
        splitValue() {
            const result = [];
            if (this.control.valueContents != this.control.oldValueContents) {
                if (this.control.status != 'DELETE') {
                    result.push({name: this.control.valueContents, icon: 'mdi mdi-checkbox-marked-circle-outline', class: 'added'});
                }
                if (this.control.status != 'NEW') {
                    result.push({name: this.control.oldValueContents, icon: 'mdi mdi-checkbox-blank-circle-outline', class: 'deleted'});
                }
            }

            return result;
        }
    }
}
</script>

<style scoped>
.deleted {
    color: red !important;
}
.added {
    color: green !important;
}
</style>